enum LoadingStatuses {
  'SUCCESS' = 'SUCCESS',
  'LOADING' = 'LOADING',
  'ERROR' = 'ERROR',
}

export default LoadingStatuses;
